<script>
import Switches from "vue-switches"
import AgreementPriceListTable from "./components/AgreementPriceListTable.vue"
import AgreementNfseFields from "./components/AgreementNfseFields.vue"
import { validateAgreement, normalizeAgreementPayload } from "@/helpers/validators/agreement"

export default {
  props: {
    currentEmpresa: { type: Object },
    listSpecialties: { type: Array, default: () => [] },
    listCodeTax: { type: Array, default: () => [] },
    currentUser: { type: Object },
  },
  components: {
    Switches,
    AgreementPriceListTable,
    AgreementNfseFields,
  },
  data() {
    return {
      convenio: {
        id: null,
        name: null,
        is_private: false,
        is_pacient_view: false,
        code_tax_id: null,
        cnpj: null,
        email: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cep: null,
        uf: 'PE',
        codigo_municipio: '',
        empresa_id: null,
      },
      convenio_itens: [],
      errors: {},
      loader: {
        get: false,
      },
    }
  },
  mounted() {
    this.$emit("newTitle", "Incluir Convênio")
    this.convenio.empresa_id = this.currentEmpresa.id
  },
  methods: {
    setPost() {
      this.errors = validateAgreement({
        convenio: this.convenio,
        priceList: this.convenio_itens,
        requirePriceList: false,
      })

      if (Object.keys(this.errors).length > 0) {
        this.$bvToast.toast(Object.values(this.errors).join(", "), {
          title: "Atenção",
          variant: "warning",
          solid: true,
        })
        return
      }

      const payload = normalizeAgreementPayload(this.convenio)
      payload.price_list = this.convenio_itens.map((item) => ({
        specialty_id: item.specialty.id,
        service_value: this.new_convert_srting_float(item.service_value),
        transfer_amount: this.new_convert_srting_float(item.transfer_amount),
      }))

      this.$emit("doPost", payload)
    },
  },
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-9">
          <label for="name">* Nome do Convênio</label>
          <input id="name" v-model="convenio.name" type="text" class="form-control" />
        </div>
        <div class="col-md-3">
          <h5 class="mt-4 font-size-14 mb-4">É Particular?</h5>
          <switches v-model="convenio.is_private" color="success" class="ml-1"></switches>
        </div>
      </div>

      <AgreementNfseFields
        :convenio="convenio"
        :listCodeTax="listCodeTax"
        :errors="errors"
      />

      <div class="row mt-3">
        <div class="col-md-12">
          <h5 class="font-size-14 mb-3">Tabela de Preços</h5>
          <AgreementPriceListTable
            v-model="convenio_itens"
            :listSpecialties="listSpecialties"
            :permission="currentUser && currentUser.roles && currentUser.roles.some(role => role.name === 'super' || role.name === 'admin')"
          />
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button v-if="!loader.get" class="btn btn-success" @click.prevent="setPost()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>
